import { render, staticRenderFns } from "./ShieldNavigation.vue?vue&type=template&id=5e661fb4&scoped=true&"
import script from "./ShieldNavigation.vue?vue&type=script&lang=js&"
export * from "./ShieldNavigation.vue?vue&type=script&lang=js&"
import style0 from "./ShieldNavigation.vue?vue&type=style&index=0&id=5e661fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e661fb4",
  null
  
)

export default component.exports